interface ComponentUpdateRangeTarget {
  updateRanges: { length: number };
  addUpdateRange(start: number, count: number): void;
}

export function addComponentUpdateRanges(
  target: ComponentUpdateRangeTarget,
  indices: ArrayLike<number>,
  itemSize: number,
): void {
  target.updateRanges.length = 0;
  if (indices.length === 0) return;

  const sorted = new Uint32Array(indices.length);
  for (let i = 0; i < indices.length; i++) sorted[i] = indices[i]!;
  sorted.sort();

  let start = sorted[0]!;
  let end = start;
  for (let i = 1; i < sorted.length; i++) {
    const index = sorted[i]!;
    if (index === end) continue;
    if (index === end + 1) {
      end = index;
      continue;
    }
    target.addUpdateRange(start * itemSize, (end - start + 1) * itemSize);
    start = index;
    end = index;
  }
  target.addUpdateRange(start * itemSize, (end - start + 1) * itemSize);
}
